<template>
  <nav class="fixed top-0 w-full bg-white/90 backdrop-blur-custom border-b border-gray-200 z-50">
    <div class="container-custom">
      <div class="flex items-center justify-between h-16">
        <!-- Logo -->
        <a href="https://www.softentra.com/products/task-manager-pro-wordpress-project-management-plugin-with-time-tracking-team-collaboration" target="_blank" class="flex items-center space-x-3">
          <img src="/logo.svg" class="w-10" alt="Logo" />
          <div>
            <h1 class="text-xl font-bold text-gray-900">Task Manager Pro</h1>
            <p class="text-xs text-gray-500">WordPress Plugin</p>
          </div>
        </a>
        
        <!-- Desktop Navigation -->
        <div class="hidden md:flex items-center space-x-8">
          <a href="#features" class="text-gray-600 hover:text-primary-600 transition-colors">Features</a>
          <a href="#screenshots" class="text-gray-600 hover:text-primary-600 transition-colors">Screenshots</a>
          <a href="#testimonials" class="text-gray-600 hover:text-primary-600 transition-colors">Reviews</a>
          <a href="#faq" class="text-gray-600 hover:text-primary-600 transition-colors">FAQ</a>
        </div>
        
        <!-- CTA Buttons -->
        <div class="flex items-center space-x-4">
          <a href="https://tmp.softentra.com/wp-admin/admin.php?page=task-manager-pro" target="_blank" class="btn-outline text-sm">Try Demo</a>
          <a href="https://www.softentra.com/products/task-manager-pro-wordpress-project-management-plugin-with-time-tracking-team-collaboration" target="_blank" class="btn-primary text-sm">
            <i class="fas fa-shopping-cart mr-2"></i>
            Buy Now
          </a>
        </div>
        
        <!-- Mobile Menu Button -->
        <button @click="toggleMobileMenu" class="md:hidden p-2 rounded-lg hover:bg-gray-100">
          <i class="fas fa-bars text-gray-600"></i>
        </button>
      </div>
      
      <!-- Mobile Menu -->
      <div v-if="mobileMenuOpen" class="md:hidden py-4 border-t border-gray-200">
        <div class="flex flex-col space-y-4">
          <a href="#features" class="text-gray-600 hover:text-primary-600 transition-colors">Features</a>
          <a href="#screenshots" class="text-gray-600 hover:text-primary-600 transition-colors">Screenshots</a>
          <a href="#testimonials" class="text-gray-600 hover:text-primary-600 transition-colors">Reviews</a>
          <a href="#faq" class="text-gray-600 hover:text-primary-600 transition-colors">FAQ</a>
          <div class="flex flex-col space-y-2 pt-4">
            <a href="https://tmp.softentra.com/wp-admin/admin.php?page=task-manager-pro" target="_blank" class="btn-outline text-sm">Try Demo</a>
            <a href="https://www.softentra.com/products/task-manager-pro-wordpress-project-management-plugin-with-time-tracking-team-collaboration" target="_blank" class="btn-primary text-sm">
              <i class="fas fa-shopping-cart mr-2"></i>
              Buy Now
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      mobileMenuOpen: false
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    }
  }
}
</script>
